module.exports = __webpack_public_path__ + "static/img/img-cp1.d2a5caf.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/img-cp1.png
// module id = TgR0
// module chunks = 0